'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Level = undefined;

var _Level2 = require('./Level');

var _Level3 = _interopRequireDefault(_Level2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Level = _Level3.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Layout/index.js
// module id = 171
// module chunks = 0